<div
  class="flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg focus:outline-none"
  role="listbox"
  [id]="panelId()"
  [style.width.px]="panelWidth() ?? 320"
  [attr.aria-labelledby]="listboxLabelledBy()"
  [attr.aria-activedescendant]="activeOptionId()"
  (keydown)="onPanelKeyDown($event)">
  <div class="relative flex w-full items-center border-b border-gray-200">
    <svg
      class="pointer-events-none absolute ml-3 text-gray-400"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      [style.width.px]="iconSize()"
      [style.height.px]="iconSize()"
      aria-hidden="true">
      <path
        d="M9.5 3C11.2239 3 12.8772 3.68482 14.0962 4.90381C15.3152 6.12279 16 7.77609 16 9.5C16 11.11 15.41 12.59 14.44 13.73L14.71 14H15.5L20.5 19L19 20.5L14 15.5V14.71L13.73 14.44C12.59 15.41 11.11 16 9.5 16C7.77609 16 6.12279 15.3152 4.90381 14.0962C3.68482 12.8772 3 11.2239 3 9.5C3 7.77609 3.68482 6.12279 4.90381 4.90381C6.12279 3.68482 7.77609 3 9.5 3ZM9.5 5C7 5 5 7 5 9.5C5 12 7 14 9.5 14C12 14 14 12 14 9.5C14 7 12 5 9.5 5Z" />
    </svg>

    <input
      #searchField
      type="text"
      aria-label="Search currencies"
      placeholder="Search..."
      class="h-11 w-full border-0 bg-transparent pr-10 pl-10 text-sm text-gray-900 outline-none placeholder:text-gray-400"
      (input)="onSearchInput($event)" />

    @if (searchQuery()) {
      <button
        type="button"
        aria-label="Clear search"
        class="absolute right-2 cursor-pointer rounded-full p-1.5 text-gray-500 hover:bg-gray-100"
        (click)="onClearSearch($event)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          [style.width.px]="iconSize() - 4"
          [style.height.px]="iconSize() - 4"
          aria-hidden="true">
          <path
            d="M12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12C2 6.47 6.47 2 12 2ZM15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z" />
        </svg>
      </button>
    }
  </div>

  <div class="max-h-60 overflow-y-auto">
    @for (currency of filteredCurrencies(); track currency.code; let index = $index) {
      <button
        type="button"
        role="option"
        class="flex w-full cursor-pointer items-center gap-3 px-4 py-3 text-left text-sm transition-colors duration-150 hover:bg-gray-100"
        [id]="optionId(currency.code)"
        [class.bg-gray-100]="highlightedIndex() === index"
        [class.text-blue-600]="isCurrencySelected(currency)"
        [class.text-gray-900]="!isCurrencySelected(currency)"
        [attr.aria-selected]="isCurrencySelected(currency)"
        (mousedown)="$event.preventDefault()"
        (click)="currencySelected.emit(currency)">
        @if (currency.flag) {
          <span class="text-base leading-none" aria-hidden="true">{{ currency.flag }}</span>
        }
        <span class="w-10 shrink-0 font-semibold">{{ currency.code }}</span>
        <span class="min-w-0 flex-1 truncate text-gray-600">{{ currency.name }}</span>
        <span class="shrink-0 text-gray-500">{{ currency.symbol }}</span>
      </button>
    } @empty {
      <span class="block px-4 py-4 text-sm text-gray-400 select-none">
        {{ noOptionsMessage() }}
      </span>
    }
  </div>
</div>
